import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-chart',
	templateUrl:'./AgChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChartPluginCompPage
{
	mdContent_703 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgChart;
\`\`\``;
	mdContent_704 = `\`\`\`java
AgChart(String id)
\`\`\``;
}
